export default "__VITE_ASSET__DJinJDdd__"